module.exports = __webpack_public_path__ + "static/img/1.517da6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/eng/1.png
// module id = fpc6
// module chunks = 0